import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

export const useGetProjectScansWithOutputsOnlyQuery = (
  projectId: string,
  scanId: string,
  workspace?: string,
  page?: number,
  earlierPage?: number,
  scene?: string
) => {
  const { authApi } = useAuth();

  const result = useQuery({
    queryKey: workspace
      ? ["scans", projectId, scanId, workspace, page, earlierPage, scene]
      : ["scans", projectId, scanId, page, earlierPage, scene],
    enabled: !!projectId && !!scanId,
    queryFn: async () => {
      const pageQuery = page ? `&page=${page}` : "";
      const earlierPageQuery = earlierPage ? `&earlierPage=${earlierPage}` : "";
      const path = workspace
        ? `/project/scans/${projectId}/${scanId}?perPage=3&workspace=${workspace}${pageQuery}${earlierPageQuery}`
        : `/project/scans/${projectId}/${scanId}?&perPage=3${pageQuery}${earlierPageQuery}`;

      const { data } = await authApi.get<OutputsOnlyQueryType>(path);
      return data;
    },
  });

  return result;
};
